import { formatOneTimePrice, type Plan } from '@/modules/auth'
import { PlanCredits } from './PlanCredits'
import PlanFeatures from './PlanFeatures'

const FEATURES = [
  'Extraction',
  'AI Chat',
  'Forensic reports',
  'Self-healing reconciliation',
]

export const SingleProjectCard = ({ plan }: { plan: Plan }) => (
  <div className="rounded-2xl border border-border bg-white p-6 sm:p-8 xl:p-10">
    <div className="flex items-start justify-between gap-6">
      <div className="pt-1">
        <h2 className="text-lg font-semibold tracking-tight xl:text-xl">
          {plan.displayName}
        </h2>
        <p className="mt-1 text-sm text-muted-foreground text-pretty">
          Everything for one matter, paid once
        </p>
      </div>

      <div className="shrink-0 text-right">
        <div className="text-4xl font-semibold tracking-tight tabular-nums leading-none xl:text-5xl">
          {formatOneTimePrice(plan)}
        </div>
        <div className="mt-1.5 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          one-time
        </div>
      </div>
    </div>

    <PlanCredits plan={plan} />

    <div className="mt-6 h-px bg-border" />

    <PlanFeatures features={FEATURES} />

    <div className="mt-6 h-px bg-border" />

    <p className="mt-4 text-xs text-muted-foreground text-pretty">
      Running low? Top up credits whenever you need them, and start another case
      any time. You only ever pay for what you use.
    </p>
  </div>
)
